import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Contact } from 'app/shared/models/contact.model';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit,OnDestroy  {
  @ViewChild('vform') validationForm: FormGroup;

  taskForm:FormGroup;
  fileData:File
  contact:any= new Contact();
  taskFormSubmitted:boolean=false;
  usersList: any[] = [];
  editData = null;
  isEdit=false;
  selectedUser:string[]=[];
  task_model={

    to: [],
    type:'',
    title: '',
    body: '',
    due_date: '',
    task_tags: '',
    messagethread: '',
    priority: '',
    label: '',
    is_schedule: '',
    scheduleduration: '',
    is_mandatory: '',
    working_hours: '',
    budget: '',
    stage: '',
    notes: '',
    admin_notes: ''
  }
  // 63e39cf92052e0098e18e003
  lead_type_catId ='63e39cf92052e0098e18e003'
  lead_type_List =[]
  selected_leadType = null

  task_stage_catId ='643e806559b78b65557d7456'
  task_stage_List =[]
  selected_task_stage = null

  task_type_catId ='643e802f59b78b65557d7452'
  task_type_List =[]
  selected_task_type = null

  task_priority_catId ='643e7faf59b78b65557d744e'
  task_priority_List =[]
  selected_task_priority = null

  task_label_catId ='643e7f6f59b78b65557d744a'
  task_label_List = []
  selected_task_label = null

  mandatory_List=[
    {id:'yes',name:'Yes'},
    {id:'no',name:'No'}
  ]
  selected_mandatory = null

  schedule_List=[
    {id:'yes',name:'Yes'},
    {id:'no',name:'No'}
  ]
  selected_schedule = null

  currentUrl:any
  task_id:any
  task_data:any
  constructor(private formBuilder: FormBuilder,
              public toastr: ToastrService, public apiService:ApiService,
              private route:Router,private activerouter: ActivatedRoute,
              ) { 
                this.currentUrl = this.activerouter.snapshot.routeConfig.path
                console.log('currentUrl=>>', this.currentUrl)
                this.activerouter.paramMap.subscribe(params => {
                  this.task_id = params.get('id');
                })
              }

  ngOnInit() {
    this.taskForm=this.formBuilder.group({
      title:  ['', Validators.required],
      body:  ['', Validators.required],
      due_date:  ['',],
      scheduleduration:  ['',],
      working_hours:  ['',],
      budget:  ['',],
      notes:  ['',],
      admin_notes:  ['',] 
    })
    this.getLeadsTypeList()
    this.getTaskLabelList()
    this.getTaskPriorityList()
    this.getTaskStageList()
    this.getTaskTypeList()
    this.getAllUsersList()

    if(this.task_id && this.currentUrl === 'edit/:id'){
      this.getTaskById()

    }
  }
  ngOnDestroy(){
    this.task_id=null
  }
  get rf() {
    return this.taskForm.controls;
  }
  getTaskById(){
    this.apiService.getTaskById(this.task_id).subscribe((res:any)=>{
      this.task_data=res.data[0]

      this.selectedUser = this.task_data?.to?.map((item)=>item._id)
      // this.selectedUser = this.task_data?.to?._id

      this.task_model.to = this.selectedUser

      this.selected_leadType = this.task_data?.type?._id
      this.task_model.type = this.selected_leadType

      this.selected_task_type = this.task_data?.task_tags?._id
      this.task_model.task_tags = this.selected_task_type

      this.selected_task_label = this.task_data?.label?._id
      this.task_model.label = this.selected_task_label

      this.selected_task_priority = this.task_data?.priority?._id
      this.task_model.priority = this.selected_task_priority

      this.selected_task_stage = this.task_data?.stage?._id
      this.task_model.stage = this.selected_task_stage

      this.selected_schedule = this.task_data?.is_schedule
      this.task_model.is_schedule = this.selected_schedule

      this.selected_mandatory = this.task_data?.is_mandatory
      this.task_model.is_mandatory = this.selected_mandatory

      this.task_model.title = this.task_data?.title
      this.task_model.body = this.task_data?.body
      this.task_model.notes = this.task_data?.notes
      this.task_model.admin_notes = this.task_data?.admin_notes
      this.task_model.budget = this.task_data?.budget
      this.task_model.working_hours = this.task_data?.working_hours
      this.task_model.due_date = this.task_data?.due_date
      this.task_model.scheduleduration = this.task_data?.scheduleduration

    })
  }
  getLeadsTypeList() {
    this.apiService.getTagByTagCatgoryId(this.lead_type_catId).subscribe((res: any) => {
      this.lead_type_List = res.data
    })
  }
  getChangeLeadType(event) {
    this.selected_leadType
  }
  getTaskStageList() {
    this.apiService.getTagByTagCatgoryId(this.task_stage_catId).subscribe((res: any) => {
      this.task_stage_List = res.data
    })
  }
  getChangeTaskStage(event) {
    this.selected_task_stage
  }
  getTaskTypeList() {
    this.apiService.getTagByTagCatgoryId(this.task_type_catId).subscribe((res: any) => {
      this.task_type_List = res.data
    })
  }
  getChangeTaskType(event) {
    this.selected_task_type
    this.task_model.type = this.selected_task_type
  }
  getTaskPriorityList() {
    this.apiService.getTagByTagCatgoryId(this.task_priority_catId).subscribe((res: any) => {
      this.task_priority_List = res.data
    })
  }
  getChangeTaskPriority(event) {
    this.selected_task_priority
    this.task_model.priority = this.selected_task_priority
  }
  getTaskLabelList() {
    this.apiService.getTagByTagCatgoryId(this.task_label_catId).subscribe((res: any) => {
      this.task_label_List = res.data
    })
  }
  getChangeTaskLabel(event) {
    this.selected_task_label
    this.task_model.label = this.selected_task_label
  }
  getChangeMandatoryId(event){
    this.selected_mandatory
  }
  getChangeScheduleId(event){
    this.selected_schedule
  }
  submit(){   
    if(this.taskForm.invalid){
      return
    }
    let body={
     
      title: this.taskForm.value.title,
      body: this.taskForm.value.body,
      scheduleduration: this.taskForm.value.scheduleduration,
      working_hours:  this.taskForm.value.working_hours,
      budget:  this.taskForm.value.budget,
      notes:  this.taskForm.value.notes,
      admin_notes: this.taskForm.value.admin_notes,
      type : this.selected_leadType,
      to: this.selectedUser,
      task_tags: this.selected_task_type,
      priority: this.selected_task_priority,
      label: this.selected_task_label,
      is_schedule: this.selected_schedule,
      is_mandatory: this.selected_mandatory,
      stage: this.selected_task_stage,

    }
    if(this.currentUrl === 'add'){
      this.apiService.createTask(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('task created successfully!')
          this.route.navigate(['/task/list'])
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.currentUrl === 'edit/:id'){
      if(this.task_model.task_tags ===null || this.task_model.task_tags ===''  ){
        delete this.task_model.task_tags
      }
      if(this.task_model.messagethread ===null || this.task_model.messagethread ===''  ){
        delete this.task_model.messagethread
      }
      this.apiService.updateTask(this.task_id,this.task_model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('task created successfully!')
          this.route.navigate(['/task/list'])    
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
  
 
  }
 back(){
  this.route.navigate(['/task/list'])    
 } 
 getAllUsersList() {
  // this.apiService.getStudentByleadsId(id).subscribe((res: any) => {
    this.apiService.getAllUsers(1,100).subscribe((res: any) => {
    if (res.statusCode ===200) {
      this.usersList = res.data.items
    }
  })
}
getSelectUserId(event:any){
  this.selectedUser
}
}

